<template>
<div class="chapter">
<div class="inner_page">
<p class="P-P33"></p>
<p class="P-P25">  </p>
<p class="P-P36">September 2, 1944</p>
<p class="P-P30"> </p>
<p class="P-P30">I suppose that I always knew, and that’s why there was no surprise. No, I think I acknowledged it in the past, never understanding what it would mean. It starts in my chest.</p>
<p class="P-P30"> </p>
<p class="P-P37">Why are they being so nice?</p>
<p class="P-P30"> </p>
<p class="P-P30">On the drive home from Memphis, everything was fine. Suddenly, they’re delicate with me, noticeably so.</p>
<p class="P-P30"> </p>
<p class="P-P37">Yes, I’m different now, but I’m still me.</p>
<p class="P-P30"> </p>
<p class="P-P30">And it cracks. A rift opens over my heart, spreading over my stomach, into my shoulders. Walking up the stairs as the sky darkens, carrying shopping bags, I tilt my head and I know.</p>
<p class="P-P30"> </p>
<p class="P-P30"><span class="S-T1">This isn’t how I thought it would be</span>.</p>
<p class="P-P30"> </p>
<p class="P-P30">I pictured falling, impassioned: dissolving. But everything is muted. I feel light as I walk into my room, placing the bags at the foot of the bed. Calm, I turn.</p>
<p class="P-P30"> </p>
<p class="P-P30">“Give it to me. Give me the letter.”</p>
<p class="P-P30"> </p>
<p class="P-P30">I had imagined snatching the paper, almost shredding it. Instead, my muscles constrict: the cracks increasing.</p>
<p class="P-P30"> </p>
<p class="P-P37">Perhaps it was folly to think I could keep them both.</p>
<p class="P-P30"> </p>
<p class="P-P30">They utter something but I don’t hear. I can’t even see the telegram as I finger for the envelope’s opening.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?855e455c